// extracted by mini-css-extract-plugin
module.exports = {"label":"MaterialLabel_label__oSb9N","onFocus":"MaterialLabel_onFocus__2fSdW","onBlur":"MaterialLabel_onBlur__3x9eK","icon":"MaterialLabel_icon__1pv_E"};